import React, { useState } from 'react';
import styles from './style.module.scss';
import { ButtonPrimary } from '@components';
import { ReactComponent as StudentLogo } from './assets/icons/StudentLogo.svg';
import { ReactComponent as ProfessionalLogo } from './assets/icons/ProfessionalLogo.svg';
import { ReactComponent as SeoLogo } from './assets/icons/SeoLogo.svg';
import { ReactComponent as TestingLogo } from './assets/icons/TestingLogo.svg';
import { useUnit } from 'effector-react';
import { $user } from '../../features/app/model'; // Ваш стор с пользователем
import { useTranslation } from 'react-i18next';
import { updateProfessionFx } from '../../features/app/model';

interface BrevoPopoverProps {
  onClose: () => void;
}

const BrevoPopover: React.FC<BrevoPopoverProps> = ({ onClose }) => {
  const { t } = useTranslation();
  const [selectedProfession, setSelectedProfession] = useState('');
  const [isUpdating, setIsUpdating] = useState(false);

  const handleUpdateProfession = async () => {
    if (!selectedProfession) return;
    
    setIsUpdating(true);
    try {
      // Используем эффект Effector
      await updateProfessionFx(selectedProfession);
      onClose();
    } catch (error) {
      console.error('Error updating profession:', error);
    } finally {
      setIsUpdating(false);
    }
  };

  return (
    <>
      <div className={styles.overlay} onClick={onClose} />
      <section className={styles.customizeSection}>
        <h2>{t('brevoPopover.title')}</h2>
        <p>{t('brevoPopover.description')}</p>

        <div className={styles.professionList}>
          <h3>{t('brevoPopover.profession')}</h3>
          <ul>
            {[
              { id: 'STUDENT', Logo: StudentLogo, label: 'brevoPopover.professions.student' },
              { id: 'SEO', Logo: SeoLogo, label: 'brevoPopover.professions.seo' },
              { id: 'PROFESSIONAL', Logo: ProfessionalLogo, label: 'brevoPopover.professions.professional' },
              { id: 'TESTING', Logo: TestingLogo, label: 'brevoPopover.professions.testing' }
            ].map((profession) => (
              <li key={profession.id} className={styles.listItem}>
                <ButtonPrimary 
                  onClick={() => setSelectedProfession(profession.id)}
                  colorScheme={selectedProfession === profession.id ? 'orange' : 'basic'}
                  disabled={isUpdating}
                >
                  <div className={styles.buttonContent}>
                    <profession.Logo className={styles.icon} />
                    <span>{t(profession.label)}</span>
                  </div>
                </ButtonPrimary>
              </li>
            ))}
          </ul>
        </div>

        <div className={styles.buttonGroup}>
          <ButtonPrimary 
            onClick={handleUpdateProfession}
            disabled={!selectedProfession || isUpdating}
            colorScheme="orange"
          >
            {isUpdating ? t('brevoPopover.buttons.updating') : t('brevoPopover.buttons.continue')}
          </ButtonPrimary>
          
          <ButtonPrimary 
            onClick={onClose}
            className={styles.secondaryButton}
            disabled={isUpdating}
          >
            {t('brevoPopover.buttons.notNow')}
          </ButtonPrimary>
        </div>
      </section>
    </>
  );
};

export default BrevoPopover;
